"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _RadarChart = _interopRequireDefault(require("../../RadarChart/RadarChart"));
var _OrganisationMember = _interopRequireDefault(require("../../OrganisationMember/OrganisationMember"));
var _PageAccordionGeneric = _interopRequireDefault(require("../../PageAccordionGeneric/PageAccordionGeneric"));
var _DownloadLinkBox = _interopRequireDefault(require("../../DownloadLinkBox/DownloadLinkBox"));
var _List = _interopRequireDefault(require("../../List/List"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.inapp-SIAprofessionalgroups-container .grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 48px; }\n\n.inapp-SIAprofessionalgroups-container .downloadlink-container p {\n  width: 100%; }\n\n.inapp-SIAprofessionalgroups-container .item-list {\n  display: flex;\n  justify-content: flex-start;\n  gap: 86px; }\n  .inapp-SIAprofessionalgroups-container .item-list .item .number {\n    font-size: 54px; }\n  .inapp-SIAprofessionalgroups-container .item-list .item .label {\n    font-size: 14px; }\n  .inapp-SIAprofessionalgroups-container .item-list .item .women-color {\n    margin-top: 16px;\n    width: 16px;\n    height: 16px;\n    background-color: #8caddb; }\n  .inapp-SIAprofessionalgroups-container .item-list .item .men-color {\n    margin-top: 16px;\n    width: 16px;\n    height: 16px;\n    background-color: #dacd7e; }\n\n.inapp-SIAprofessionalgroups-container .section-info {\n  display: flex;\n  gap: 48px;\n  justify-content: space-between; }\n\n.inapp-SIAprofessionalgroups-container .OrganisationMember-container {\n  margin: 0px; }\n  .inapp-SIAprofessionalgroups-container .OrganisationMember-container .info-container {\n    margin-bottom: 0px; }\n\n.inapp-SIAprofessionalgroups-container .right-content {\n  width: 100%; }\n\n.inapp-SIAprofessionalgroups-container .bx--accordion__title {\n  color: #e41b13;\n  font-family: 'Helvetica Neue LT Roman';\n  font-size: 16px;\n  margin-left: 0px; }\n\n.inapp-SIAprofessionalgroups-container .bx--accordion__heading:focus::before {\n  border-width: 0px; }\n\n.inapp-SIAprofessionalgroups-container .bx--accordion__heading:hover::before {\n  opacity: 0.3; }\n\n.inapp-SIAprofessionalgroups-container .bx--accordion__item:nth-child(1) {\n  border-top: none; }\n\n.inapp-SIAprofessionalgroups-container .bottom-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; }\n  .inapp-SIAprofessionalgroups-container .bottom-content .organisationMember-content {\n    display: flex;\n    align-self: flex-end;\n    margin-right: 40px;\n    max-width: 100%;\n    flex-wrap: wrap; }\n\n.inapp-SIAprofessionalgroups-container .list-container {\n  padding-right: 64px; }\n\n@media (max-width: 66rem) {\n  .inapp-SIAprofessionalgroups-container .bottom-content {\n    flex-direction: column;\n    gap: 16px;\n    align-items: flex-start; }\n    .inapp-SIAprofessionalgroups-container .bottom-content .organisationMember-content {\n      margin-right: 24px;\n      flex-direction: column;\n      gap: 16px; }\n  .inapp-SIAprofessionalgroups-container .OrganisationMember-container .info-container {\n    margin-left: 0px; } }\n\n@media (max-width: 42rem) {\n  .inapp-SIAprofessionalgroups-container .bottom-content {\n    align-items: flex-start; }\n    .inapp-SIAprofessionalgroups-container .bottom-content .organisationMember-content {\n      margin-right: 0px;\n      flex-direction: column; }\n  .inapp-SIAprofessionalgroups-container .section-info {\n    flex-direction: column;\n    align-items: center; }\n  .inapp-SIAprofessionalgroups-container .item-list {\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 48px; }\n  .inapp-SIAprofessionalgroups-container .grid {\n    grid-template-columns: 100%; } }\n";
  const fileName = "InAppSIAProfessionalGroups_InAppSIAProfessionalGroups";
  const element = document.querySelector("style[data-sass-component='InAppSIAProfessionalGroups_InAppSIAProfessionalGroups']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const AccordionContent = _ref => {
  let {
    item
  } = _ref;
  const items = item?.sort((el, el2) => el.weight - el2.weight).map((el, i) => {
    return {
      content: el.website ? `<a href="${el.website}" target="_blank">${el.code} - ${el.name}</a>` : el.name ? el.name : `${el.lastname} ${el.firstname}, ${el.diploma_title}, ${el.city}, ${el.role}`
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "item"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-container"
  }, /*#__PURE__*/_react.default.createElement(_List.default, {
    title: '',
    items: items,
    variant: 'UNORDERED'
  }))));
};
const min = (a, b) => a < b ? a : b;
const max = (a, b) => a > b ? a : b;
const Chart = /*#__PURE__*/_react.default.memo(_ref2 => {
  let {
    ...args
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_RadarChart.default, args);
});
const TopContent = _ref3 => {
  let {
    translate,
    stats
  } = _ref3;
  const [width, setWidth] = (0, _react.useState)(0);
  const [height, setHeight] = (0, _react.useState)(0);
  const ref = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    const widthAux = ref?.current?.clientWidth || 400;
    setWidth(widthAux);
    setHeight(max(min(widthAux * 0.55, 500), 230));
  }, []);
  const args = {
    colors: {
      Women: 'SIAazure',
      Men: 'SIAyellow'
    },
    width: `${width}px`,
    height: `${height}px`,
    fillMode: 'low',
    showTotal: true,
    alignment: width < 650 ? 'center' : 'left'
  };
  const chartItems = _react.default.useMemo(() => {
    if (Object.entries(stats)?.length > 0) {
      return {
        Men: Object.fromEntries(Object.entries(stats)?.filter(_ref4 => {
          let [key, value] = _ref4;
          return !key.includes('professional_group_stats');
        })?.map(_ref5 => {
          let [key, value] = _ref5;
          return [key, value[0].total_men];
        })),
        Women: Object.fromEntries(Object.entries(stats)?.filter(_ref6 => {
          let [key, value] = _ref6;
          return !key.includes('professional_group_stats');
        })?.map(_ref7 => {
          let [key, value] = _ref7;
          return [key, value[0].total_women];
        }))
      };
    }
    return {};
  }, [stats]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "right-content sia-padding-02-top"
  }, stats?.professional_group_stats && /*#__PURE__*/_react.default.createElement("div", {
    className: "item-list sia-padding-04-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "item"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-14 number"
  }, stats.professional_group_stats[0].total_women + stats.professional_group_stats[0].total_men), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-11 label"
  }, translate('cms.inapp.professional_groups.members'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "item"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-14 number"
  }, stats.professional_group_stats[0].total_women), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-11 label"
  }, translate('cms.inapp.professional_groups.women')), /*#__PURE__*/_react.default.createElement("div", {
    className: "women-color"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "item"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-14 number"
  }, stats.professional_group_stats[0].total_men), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-11 label"
  }, translate('cms.inapp.professional_groups.men')), /*#__PURE__*/_react.default.createElement("div", {
    className: "men-color"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "chart-container",
    ref: ref,
    style: {
      minHeight: `${height}px`
    }
  }, chartItems && stats && height && /*#__PURE__*/_react.default.createElement(Chart, _extends({}, args, {
    items: chartItems
  }))));
};
const BottomContent = _ref8 => {
  let {
    information,
    translate,
    history
  } = _ref8;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom-content sia-padding-05-top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "organisationMember-content sia-padding-05-bottom"
  }, information?.president?.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, information?.president.map((president, i) => {
    return /*#__PURE__*/_react.default.createElement(_OrganisationMember.default, _extends({
      key: i
    }, president, {
      professional_group_membership: president.professional_group[0].name,
      section_memberships: president.sections.map(group => group.name),
      sia_membership: president.member_type,
      picture: president.image ? 'data:image/png;base64,' + president.image : null
    }));
  }))), /*#__PURE__*/_react.default.createElement(_PageAccordionGeneric.default, {
    item: {
      accordion_generic_element: Object.entries(information?.accordion || {})?.filter(item => item[1])?.map(item => {
        return {
          col_0: [item[1]],
          accordion_generic_el_title: [translate('cms.inapp.professional_groups.' + item[0])]
        };
      })
    },
    Item: AccordionContent,
    history: history
  }));
};
const InAppSIAProfessionalGroups = _ref9 => {
  let {
    translate,
    lang,
    data,
    history
  } = _ref9;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inapp-SIAprofessionalgroups-container sia-margin-02-right sia-padding-05-bottom sia-margin-02-bottom"
  }, data && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TopContent, {
    stats: data.stats,
    translate: translate
  }), /*#__PURE__*/_react.default.createElement(BottomContent, {
    information: data.information,
    translate: translate,
    history: history
  })));
};
var _default = exports.default = InAppSIAProfessionalGroups;